export const SET_QUERY_SUCCESS = "@query/set-query-success";
export const SET_QUERY_FILTERS_SUCCESS = "@query/set-query-filters-success";

export function setQuerySuccess(query) {
  return { type: SET_QUERY_SUCCESS, payload: { query } };
}


export function setQueryFiltersSuccess(filters) {
  return { type: SET_QUERY_FILTERS_SUCCESS, payload: { filters } };
}
